import { Controller, Path, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { BLANK_OPTION, IFormValues, IGetProvincesReturn, IMapField } from "../../types";
import Autocomplete from "@mui/material/Autocomplete";
import { FunctionComponent, useEffect, useState } from "react";
import TextField from "@mui/material/TextField";

interface CBProvinceControllerProps {
    provinceOptions: IMapField[] | [],
    idField?: string,
    formName: Path<IFormValues>,
    label: string,
    readOnly?: boolean,
    isMandatory?: boolean,
    isDisabled?: boolean,
    showSelect: boolean
}

const CBProvinceController: FunctionComponent<CBProvinceControllerProps> = ({
    provinceOptions,
    formName, 
    label, 
    readOnly=false, 
    idField, 
    showSelect, 
    isMandatory = false, 
    isDisabled = false
}) => {
    
    const { t } = useTranslation('customerbase');
    const formContext = useFormContext<IFormValues>();

    /*const [provinceOptions, setProvinceOptions] = useState<{key: string, value: string}[] | []>([]);

    const {refetch} = useQuery(['getProvincesByCountry'], {
        enabled: false,
        queryFn: () => {
            
            if(!!country) 
                return getProvincesByCountry(country);
        },
        onSuccess: (data: any) => {

            const provinces: IGetProvincesReturn = data?.data;

            if(!!provinces && !!provinces.data && provinces.data.length>0)
                setProvinceOptions(provinces.data.map((p) => ({
                    key: p.codeProvince || '',
                    value: p.description || ''
                })) || []);
        },
        onError: (err: any) => {
            setProvinceOptions([]);
        }

    });*/

    /*useEffect(() => {

        formContext.setValue(formName, "");
    }, [provinceOptions, formName])*/

    return (
        <>
            {showSelect ?
                <Controller
                    control={formContext.control}
                    name={formName}
                    render={({field, fieldState}) => (
                        <Autocomplete
                            {...field}
                            fullWidth
                            openOnFocus
                            autoHighlight
                            autoSelect
                            id={idField}
                            disabled={isDisabled}
                            options={isMandatory ? provinceOptions : (!!provinceOptions && provinceOptions.length > 0 ? [BLANK_OPTION, ...provinceOptions] : provinceOptions)}
                            renderInput={(params: any) => (
                                <TextField 
                                    {...params}
                                    fullWidth
                                    label={t(label)}
                                    required={isMandatory}
                                    error={Boolean(fieldState.error)}
                                    helperText={fieldState.error?.message}                        
                                />
                            )}
                            //value={field.value && field.value !== "--"? ( provinceOptions.length > 0 ? provinceOptions.find((p) => p.key == field.value) : {key: field.value, value: field.value}) : null}
                            value={field.value ? provinceOptions.find((p) => p.key == field.value) || null : null}
                            getOptionLabel={(option: any) => !!option?.value ? option?.value : ""}
                            onChange={(_event, value) => {
                                field.onChange(value);
                                formContext.setValue(formName, value?.key || "");
                            }}
                            /*onOpen={() => {
                                    console.log("Province Country: ", country);
                                    console.log("Province From: ", formName);
                                if(!!country && country !== "--"){
                                    
                                    refetch();
                                }
                            }}
                            onClose={() => {
                                setProvinceOptions([]);
                            }}*/
                        />
                    )}
                    
                />
            :
                <Controller
                    control={formContext.control}
                    name={formName}
                    render={({field, fieldState}) => (
                        <TextField 
                            {...field}
                            fullWidth
                            InputProps={{
                                readOnly: true
                            }}
                            //disabled={isDisabled}
                            label={t(label) + (isMandatory ? ' *' : '')}
                            value={field.value ? provinceOptions.find((p) => p.key == field.value)?.value || "--" : "--"}
                            //value={field.value ? provinceOptions.find((p) => p.key == field.value)?.value || (isCreationMode ? '' : "--") : (isCreationMode ? '' : "--")}
                            //error={isCreationMode && Boolean(fieldState.error)}
                            //helperText={isCreationMode && fieldState.error?.message}
                        />
                    )}
                
                />
            }
        </>

    );

}

export default CBProvinceController;